import { useThemeStatusStore } from 'store/themeStatus.store';
import classes from 'components/widgets/RiskDensity/components/CriticalAnalysisHeatMap/CriticalAnalysisHeatMap.module.scss';
import { ISerializeHeatmapReturn } from 'components/widgets/RiskDensity/RiskDensity.utils';
import {
    serializeData,
    serializeOptions,
} from 'components/widgets/RiskDensity/components/CriticalAnalysisHeatMap/CriticalAnalysisHeatMap.utils';
import { HeatmapChart } from 'components/common/charts/heatmapChart/heatmapChart';

interface Props {
    data: ISerializeHeatmapReturn[];
    handleClick: (value: string) => void;
    resolution: boolean;
    noData: boolean;
    isFetching: boolean;
}

const CriticalAnalysisHeatMap = ({ data, handleClick, resolution, noData, isFetching }: Props) => {
    const { themeStatus } = useThemeStatusStore();

    const series = serializeData(data);
    const options = serializeOptions({
        data,
        themeStatus,
        handleClick,
        isWeekResolution: resolution,
    });

    return (
        <div className={classes.criticalAnalysisHeatMapContainer}>
            <HeatmapChart series={series} options={options} noData={noData} isFetching={isFetching} height={180} />
        </div>
    );
};

export default CriticalAnalysisHeatMap;
